<script setup lang="ts">
withDefaults(
  defineProps<{
    count: number
    variant?: "default" | "danger"
    indeterminate?: boolean
  }>(),
  {
    variant: "default",
    indeterminate: false,
  },
)
</script>

<template>
  <div class="gpx-badge-wrapper">
    <span v-if="indeterminate || count" class="gpx-badge" :class="`gpx-badge_${variant}`">
      {{ indeterminate || !count ? "–" : count }}
    </span>
    <slot />
  </div>
</template>

<style scoped>
.gpx-badge-wrapper {
  position: relative;
  display: flex;
  width: max-content;
  height: max-content;
}

.gpx-badge {
  --offset: -10px;

  position: absolute;
  top: var(--offset);
  right: var(--offset);
  padding: 0.25rem 0.65rem;
  border-radius: 9999px;
  font-family: Montserrat, "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  min-width: 0.5rem;
  display: flex;
  place-content: center center;
}

.gpx-badge_default {
  background: var(--template-primary-colour);
  color: var(--template-primary-button-text);
}

.gpx-badge_danger {
  background: red;
  color: white;
}
</style>
